(function (busNycView, $) {
  var busNycSection;
  var busNycSectionHeight;
  var busNycSectionOffsetTop;
  var statueOfLiberty;
  var statueOfLibertyShadow;
  var isTouchEvent = Modernizr.touchevents;

  busNycView.init = function () {
    busNycSection = $("#bus-nyc-section");
    if (busNycSection.length <= 0) {
      return;
    }
    statueOfLiberty = $("#statue-of-liberty-holder");
    statueOfLibertyShadow = $("#statue-of-liberty-shadow");

    calculateGeometry();
    setTimeout(calculateGeometry, 2000);
    setTimeout(calculateGeometry, 6000);
    setInterval(calculateGeometry, 18000);

    wireEvents();
  };

  function wireEvents() {
    el.documentElement.on("WINDOW_RESIZED_EVENT", function () {
      calculateGeometry();
    });

    if (!isTouchEvent) {
      el.documentElement.on("WINDOW_SCROLL_EVENT", function (evt, windowScrollTop) {
        var sectionOffset = windowScrollTop - busNycSectionOffsetTop + el.windowHeight;

        if (el.windowWidth < 768 || sectionOffset < 0 || sectionOffset > busNycSectionHeight * 2) {
          return;
        }

        var distanceFromBottomOfSection = el.windowHeight - sectionOffset + busNycSectionHeight / 4; //200 desktop 600 desktop

        //var animSpeed = 0.9; // larger = faster
        //var animDistance = 800; // distance into the section before anim starts
        //var offset = Math.min(0, (distanceFromBottomOfSection-animDistance) * animSpeed);
        statueOfLiberty.css("bottom", Math.min(0, -distanceFromBottomOfSection) + "px");
        statueOfLiberty.css("left", Math.min(0, -distanceFromBottomOfSection) + "px");

        var lowerExtremities = -90;
        var upperExtremity = 40;
        var shadowOffsetLeft = Math.max(lowerExtremities, sectionOffset - 1200) / 10;
        shadowOffsetLeft = Math.min(shadowOffsetLeft, upperExtremity);
        statueOfLibertyShadow.css("left", shadowOffsetLeft);
      });
    }
  }

  function calculateGeometry() {
    if (el.windowWidth >= 768) {
      busNycSectionHeight = busNycSection.height();
      busNycSectionOffsetTop = busNycSection.offset().top;
    }
  }
})((window.el.BusNycView = window.el.BusNycView || {}), jQuery);
